class LoadMoreArticles extends HTMLElement {
  constructor() {
    super();
    this.currentPage = parseInt(this.dataset.currentPage) || 1;
    this.totalPages = parseInt(this.dataset.totalPages) || 1;
    this.articlesContainer = document.getElementById('blog-main-content');

    // Check if we're already on the last page
    if (this.currentPage >= this.totalPages) {
      this.remove();
      return;
    }

    // Render the button
    this.innerHTML = `
      <button type="button" class="load-more-btn">Load more</button>
      <style>
        load-more-articles {
          display: block;
          text-align: center;
          margin: 40px auto;
        }

        .load-more-btn {
          background: white;
          color: black;
          border: 1px solid black;
          font-family: 'Filamint Medium';
          text-transform: uppercase;
          padding: 16px 39px;
          font-size: 16px;
          cursor: pointer;
        }

        load-more-articles.loading .load-more-btn {
          opacity: 0.6;
          cursor: wait;
        }

        load-more-articles.disabled .load-more-btn {
          opacity: 0.4;
          cursor: not-allowed;
        }
      </style>
    `;

    this.button = this.querySelector('.load-more-btn');
    this.button.addEventListener('click', this.loadMore.bind(this));
  }

  async loadMore() {
    this.classList.add('loading');
    this.button.textContent = 'Loading...';

    const blogUrl = this.dataset.blogUrl;
    const nextPage = this.currentPage + 1;

    try {
      const response = await fetch(`${blogUrl}?page=${nextPage}&view=ajax`);
      const html = await response.text();

      if (html.trim()) {
        const temp = document.createElement('div');
        temp.innerHTML = html;

        const newSection = temp.querySelector('.articles-normal-grid-section');
        const noMorePages = temp.querySelector('[data-no-more-pages]');

        if (newSection) {
          this.articlesContainer.appendChild(newSection);

          this.currentPage = nextPage;
          this.classList.remove('loading');

          // Update URL without reloading
          const url = new URL(window.location);
          url.searchParams.set('page', nextPage);
          window.history.pushState({}, '', url);

          if (noMorePages || this.currentPage >= this.totalPages) {
            this.remove();
          } else {
            this.button.textContent = 'Load more';
          }
        } else {
          this.button.textContent = 'No more articles';
          this.classList.add('disabled');
        }
      } else {
        this.button.textContent = 'No more articles';
        this.classList.add('disabled');
      }
    } catch (error) {
      console.error('Error loading more articles:', error);
      this.button.textContent = 'Error loading articles';
      this.classList.remove('loading');
    }
  }
}

customElements.define('load-more-articles', LoadMoreArticles);
